module.exports = __webpack_public_path__ + "img/gmail-logo.8ac3b5d4.png";